import React, { useMemo } from 'react'
import { notification as AntNotification } from 'antd'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { NOTIFICATION_CLASS_NAMES, NotificationGlobalStyles } from './styled'

const closeIcon = <FontAwesomeIcon icon={faTimes} />

const createNotificationHandlers = () => {
  const success = (message: string) => {
    AntNotification.success({
      className: NOTIFICATION_CLASS_NAMES.success,
      icon: <FontAwesomeIcon icon={faCheckCircle} />,
      closeIcon,
      message,
    })
  }

  const successWithDescription = (message: string, description: string) => {
    AntNotification.success({
      className: NOTIFICATION_CLASS_NAMES.success,
      icon: <FontAwesomeIcon icon={faCheckCircle} />,
      closeIcon,
      message,
      description,
    })
  }

  const info = (message: string) => {
    AntNotification.info({
      className: NOTIFICATION_CLASS_NAMES.info,
      icon: <FontAwesomeIcon icon={faInfoCircle} />,
      closeIcon,
      message,
    })
  }

  const warning = (message: string) => {
    AntNotification.warning({
      className: NOTIFICATION_CLASS_NAMES.warning,
      icon: <FontAwesomeIcon icon={faInfoCircle} />,
      closeIcon,
      message,
    })
  }

  const error = (message: string) => {
    AntNotification.error({
      className: NOTIFICATION_CLASS_NAMES.error,
      icon: <FontAwesomeIcon icon={faTimesCircle} />,
      closeIcon,
      message,
    })
  }

  const loading = (message: string, key?: string) => {
    AntNotification.open({
      key,
      className: NOTIFICATION_CLASS_NAMES.info,
      icon: <FontAwesomeIcon icon={faSpinner} spin />,
      closeIcon,
      message,
      duration: 0,
    })
  }

  const close = (key: string) => {
    AntNotification.close(key)
  }

  return {
    success,
    successWithDescription,
    info,
    warning,
    error,
    loading,
    close,
  }
}

export const useNotification = () => {
  const handlers = useMemo(() => createNotificationHandlers(), [])
  return handlers
}

export const NotificationStylesProvider: React.FC = () => (
  <NotificationGlobalStyles />
)
